import { render, staticRenderFns } from "./LinkGen.vue?vue&type=template&id=92074e36&scoped=true&"
import script from "./LinkGen.vue?vue&type=script&lang=js&"
export * from "./LinkGen.vue?vue&type=script&lang=js&"
import style0 from "./LinkGen.vue?vue&type=style&index=0&id=92074e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92074e36",
  null
  
)

export default component.exports